<template>
  <div>
    <titulo-modulo titulo="Atestados" />
    <v-progress-linear indeterminate v-if="carregando"></v-progress-linear>
    <template v-else>
      <v-alert type="info" text class="mt-1">
        <h4>Prazo de Entrega</h4>
        <p class="mb-0">
          Todos os documentos devem ser entregues no prazo de 48 horas a contar
          do início do afastamento, exceto no último dia do mês, quando o prazo
          é de 24 horas para a entrega.
        </p>
      </v-alert>
      <v-btn rounded color="info" :to="{name: 'enviar-atestado'}">
        <v-icon size="18" class="mr-2">mdi-upload</v-icon>Enviar Atestado</v-btn
      ><atualizar-atestados />
      <listar-atestados v-if="atestados.length > 0" />
    </template>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import TituloModulo from "../../components/TituloModulo.vue";
import AtualizarAtestados from './listar-atestados/components/AtualizarAtestados.vue';
import ListarAtestados from "./listar-atestados/ListarAtestados.vue";
export default {
  components: {
    TituloModulo,
    ListarAtestados,
    AtualizarAtestados,
  },
  computed: mapState("atestado", ["minHeight", "atestados"]),
  data: () => ({
    carregando: false,
  }),
  
  methods: {
    ...mapActions("atestado", ["getAtestados", "getStatus"]),
    ...mapMutations("atestado", ["setDados", "setNrDias"]),
  },
  async mounted() {
    this.carregando = true;
    this.setDados("ATESTADOS");
    this.setNrDias(1);
    await this.getAtestados();
    await this.getStatus();
    this.carregando = false;
  },
};
</script>

